import React from 'react';
import { InstagramIcon, MessageCircleIcon } from 'lucide-react';
import { NAV_LINKS, CONTACT_INFO, IMAGES } from '../data/site';
export function Footer() {
  return <footer className="bg-ink pt-20 pb-10" data-id="element-113" data-mp="3gh3sii3dgcgq">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-114" data-mp="32ovwwtntqrjm">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-115" data-mp="32m1ef7odfgsu">
          <div className="lg:col-span-5" data-id="element-116" data-mp="36q953aee36tp">
            <div className="flex items-center gap-3" data-id="element-117" data-mp="36n3grxdl48z1">
              <span className="inline-flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white" data-id="element-118" data-mp="3ugbqj7nstejc">
                <img src={IMAGES.logo} alt="Silver Hogar" className="h-full w-full object-contain p-1" data-id="element-119" data-mp="36mrsgl2ksqw" />
              </span>
              <span className="flex flex-col leading-none" data-id="element-120" data-mp="3qfjiuiukrhp6">
                <span className="text-lg font-semibold tracking-tight text-white" data-id="element-121" data-mp="29y5gjzn2fiuh">
                  Silver <span className="text-brand" data-id="element-122" data-mp="2eyjprl0ekyu3">Hogar</span>
                </span>
                <span className="mt-1 text-[10px] uppercase tracking-[0.2em] text-white/50" data-id="element-123" data-mp="3l9ahbtogro9p">
                  Muebles · Electrodomésticos
                </span>
              </span>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60" data-id="element-124" data-mp="3v7gbtq7xxs4j">
              5 años equipando hogares con muebles y electrodomésticos de calidad, atención
              personalizada y un servicio que continúa después de la entrega.
            </p>
          </div>

          <nav className="lg:col-span-3" aria-label="Enlaces rápidos" data-id="element-125" data-mp="33xe1y3atysi">
            <h2 className="text-xs uppercase tracking-[0.18em] text-white/40" data-id="element-126" data-mp="33nmw76ipll8">Enlaces rápidos</h2>
            <ul className="mt-5 space-y-3" data-id="element-127" data-mp="hs1wr22cqaba">
              {NAV_LINKS.map(link => <li key={link.href} data-id="element-128" data-mp="cu8uul8302gt">
                  <a href={link.href} className="text-sm text-white/70 transition-colors hover:text-brand" data-id="element-129" data-mp="qthy6kb6v23d">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-4" data-id="element-130" data-mp="tt9y8bqxspv4">
            <h2 className="text-xs uppercase tracking-[0.18em] text-white/40" data-id="element-131" data-mp="ytekkiej0et9">Contacto</h2>
            <ul className="mt-5 space-y-3 text-sm text-white/70" data-id="element-132" data-mp="13sr7121hjjvb">
              <li data-id="element-133" data-mp="13rfyyq10bpye">{CONTACT_INFO.address}</li>
              <li data-id="element-134" data-mp="18l2ecpyk27xw">{CONTACT_INFO.whatsapp}</li>
              <li data-id="element-135" data-mp="18ltzt7yfupag">
                <a href={`mailto:${CONTACT_INFO.email}`} className="transition-colors hover:text-brand" data-id="element-136" data-mp="1clup5nn2skwa">
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li className="text-white/50" data-id="element-137" data-mp="1mktpmixota87">{CONTACT_INFO.hours}</li>
            </ul>
            <div className="mt-6 flex items-center gap-3" data-id="element-138" data-mp="1rj4xwp8c3cob">
              {[{
              icon: InstagramIcon,
              label: 'Instagram',
              href: CONTACT_INFO.instagramUrl
            }, {
              icon: MessageCircleIcon,
              label: 'WhatsApp',
              href: CONTACT_INFO.whatsappUrl
            }].map(({
              icon: SocialIcon,
              label,
              href
            }) => <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={`${label} de Silver Hogar`} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors hover:border-brand hover:bg-brand hover:text-white" data-id="element-139" data-mp="25o57ec76hf9i">
                  <SocialIcon className="h-5 w-5" strokeWidth={1.5} aria-hidden="true" data-id="element-140" data-mp="2pcw5kal6rdu4" />
                </a>)}
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-141" data-mp="2fezvzn7wcqy4">
          <p className="text-xs text-white/40" data-id="element-142" data-mp="18zpjslnmpfz1">
            © {new Date().getFullYear()} Silver Hogar. Todos los derechos reservados.
          </p>
          <p className="text-xs text-white/40" data-id="element-143" data-mp="2rvzlfa75dzs4">Muebles y electrodomésticos · Desde 2021</p>
        </div>
      </div>
    </footer>;
}